import React from 'react';
import { TabsContent } from "@/components/ui/tabs";
import { TimePeriod, getTimeRangeLabel } from "@/utils/dashboardUtils";
import MonthlyActivityChart from "../MonthlyActivityChart";
import CO2ByTypeChart from "../CO2ByTypeChart";
import OverviewStatsCards from "../OverviewStatsCards";

interface OverviewTabProps {
  isLoading: boolean;
  activePeriod: TimePeriod;
  monthlyData: any[];
  co2ByTypeData: any[];
  overviewStats?: {
    totalRides: number;
    totalUsers: number;
    totalOffsetRides: number;
    totalDistance: number;
    totalOffsetDistance: number;
    totalCO2Offset: number;
  };
}

const OverviewTab: React.FC<OverviewTabProps> = ({
  isLoading,
  activePeriod,
  monthlyData,
  co2ByTypeData,
  overviewStats
}) => {
  return (
    <TabsContent value="overview" className="space-y-6">
      <OverviewStatsCards
        isLoading={isLoading}
        data={overviewStats}
      />
      
      <MonthlyActivityChart
        isLoading={isLoading}
        data={monthlyData}
      />
      
      <CO2ByTypeChart
        data={co2ByTypeData}
        periodLabel={getTimeRangeLabel(activePeriod)}
      />
    </TabsContent>
  );
};

export default OverviewTab;
